import { IClassroomResource } from "../../classrooms";
import { createApiQueryHook, IApiQueryFunction, IPaginateable, mapPagination } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { serialize } from "../../utils/url";
import { ICalendarEventList } from "../types";

export interface ICalendarEventListQueryParameters extends IPaginateable {
    classroom?: RelationalValue<IClassroomResource>;
    filters?: {
        startAtBefore?: string;
        startAtAfter?: string;
        endAtBefore?: string;
        endAtAfter?: string;
    };
}

export type ICalendarEventListQueryResult = ICalendarEventList;

const mapFilters = (filters: ICalendarEventListQueryParameters["filters"]) => {
    const { startAtAfter, startAtBefore, endAtBefore, endAtAfter } = filters ?? {};
    return {
        "startAt[before]": startAtBefore,
        "startAt[after]": startAtAfter,
        "endAt[before]": endAtBefore,
        "endAt[after]": endAtAfter,
    };
};

export const calendarEventListQuery: IApiQueryFunction<ICalendarEventListQueryParameters> = ({
    classroom,
    filters,
    pagination,
}) => {
    if (!classroom) {
        return;
    }

    return {
        method: "GET",
        url: `/classrooms/${mapRelationalValue(classroom)}/calendar${serialize(
            {
                ...mapPagination(pagination),
                ...mapFilters(filters),
            },
            true,
        )}`,
    };
};

export const useCalendarEventListQuery = createApiQueryHook<
    ICalendarEventListQueryParameters,
    ICalendarEventListQueryResult
>(calendarEventListQuery);
